<div id="page-calendar">
    <h2 id="section-title" translate>calendar.pagetitle</h2>
    <p *ngIf="host" class="page-section-description" translate>calendar.bodyCounselor</p>
    <p *ngIf="!host" class="page-section-description" translate>calendar.bodyUser</p>

    <div class="calendar">
        <div class="row text-center" id="nav-buttons">
            <div class="col-md-4 col-xs-12">
                <div autoFocus tabindex="0" role="button" id="previous" class="btn btn-inline" mwlCalendarPreviousView [view]="view"
                    [(viewDate)]="viewDate" (viewDateChange)="activeDayIsOpen = false" translate>
                    calendar.previous
                </div>
            </div>
            <div class="col-md-4 col-xs-12">
                <h3>{{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}</h3>
            </div>
            <div class="col-md-4 col-xs-12">
                <div tabindex="0" role="button" id="next" class="btn btn-inline" mwlCalendarNextView [view]="view"
                    [(viewDate)]="viewDate" (viewDateChange)="activeDayIsOpen = false" translate>
                    calendar.next
                </div>
            </div>
        </div>
        <mwl-calendar-month-view [viewDate]="viewDate" [events]="events" (dayClicked)="dayClicked($event)">
        </mwl-calendar-month-view>
    </div>

    <div class="mini-legend">
        <div class="item moodcheck-bullet" translate tabindex="0">
            <i class="bullet"></i>calendar.legend.moodcheck
        </div>

        <div class="item assessment-bullet" translate tabindex="0">
            <i class="bullet"></i>calendar.legend.assessment
        </div>

        <div class="item depression-bullet" translate tabindex="0">
            <i class="bullet"></i>calendar.legend.depression
        </div>

        <div class="item anxiety-bullet" translate tabindex="0">
            <i class="bullet"></i>calendar.legend.anxiety
        </div>

        <div class="item thoughtdiary-bullet" translate tabindex="0">
            <i class="bullet"></i>calendar.legend.thoughtdiary
        </div>

        <div class="item funachievement-bullet" translate tabindex="0">
            <i class="bullet"></i>calendar.legend.funachievement
        </div>

        <div class="item inprogress-activityscheduler-bullet" translate tabindex="0">
            <i class="bullet"></i>calendar.legend.inprogress
         </div>
        <div class="item completed-activityscheduler-bullet" translate tabindex="0">
            <i class="bullet"></i>calendar.legend.completed
         </div>

        <div class="item zenroom-bullet" translate tabindex="0">
            <i class="bullet"></i>calendar.legend.zenroom
        </div>
    </div>

    <div class="event-listing" tabindex="0">   
        <event-listing-component [activeEvents]="activeEvents" [pickedDate]="pickedDate"></event-listing-component>
    </div>
 
</div>